/**
 * HubSpot meeting page of the expert follow-up meeting (« réunion de suivi expert »).
 *
 * Used both when a trial is activated and from the support page.
 */
export const EXPERT_FOLLOW_UP_MEETING_URL = 'https://meetings.hubspot.com/meetings/b-petitpre/reunion-de-suivi-expert';

const SupportService = () => {
    /**
     * Open the CEOSupport window.
     */
    const openCEOSupportWindow = () => {
        const supportUrl = 'https://meetings.hubspot.com/thomas-brunet?uuid=a0df9fb4-f957-4b00-856d-8f8d7c1c4823';

        window.open(supportUrl);
    };

    /**
     * Open the Apodis Premium Support window.
     */
    const openApodisPremiumSupportWindow = () => {
        const supportUrl = "https://meetings.hubspot.com/alexis-perret/apodis-premium";

        window.open(supportUrl);
    };

    /**
     * Open the expert follow-up meeting booking page.
     */
    const openExpertFollowUpMeetingWindow = () => {
        window.open(EXPERT_FOLLOW_UP_MEETING_URL);
    };

    return {
        openCEOSupportWindow,
        openApodisPremiumSupportWindow,
        openExpertFollowUpMeetingWindow,
    };
};

export default SupportService();
